import * as React from 'react';

import { ApolloError } from 'apollo-client';
import { Mutation } from 'react-apollo';

import ToastActions from 'actions/ToastActions';

import {
    EnableOrDisableDeviceVariables
} from 'settings/queries/__generated__/EnableOrDisableDevice';

import DEVICES_QUERY from 'settings/queries/devicesQuery.gql';
import ENABLE_DISABLE_DEVICE_MUTATION from 'settings/queries/EnableOrDisableDeviceMutation.gql';

type Props = {
  children: (
    enableOrDisableDevice: (input: { variables: EnableOrDisableDeviceVariables }) => void
  ) => React.ReactElement;
};

export default function EnableOrDisableDeviceMutationContainer(props: Props) {
  return (
    <Mutation
      mutation={ENABLE_DISABLE_DEVICE_MUTATION}
      // @ts-ignore ts upgrade with new apollo-link update borked things.  Type mismatch between graphql libraries.
      refetchQueries={() => [{ query: DEVICES_QUERY }]}
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
      {props.children}
    </Mutation>
  );
}
